import { EventService } from '~/lib/services/event-service'
import { defineServiceComposable } from '~/composables/service-container'

export const useEventService = defineServiceComposable(
  'event',
  (nuxtApp) =>
    new EventService(nuxtApp, {
      apiService: useApiService(),
      clientCookieService: useClientCookieService(),
    }),
)
